import { DeliveryAddress, IRestaurantDeliveryAddress, PutDeliveryAddress } from "../models/IRestaurantDeliveryAddress";
import { AdminRestaurantList, IRestaurantDetail, RestaurantList } from "../models/IRestaurantDetail";
import { IUpdateRestaurant } from "../models/IUpdateRestaurant";
import { IWorkingHour, IWorkingHourCreate, IWorkingHourUpdate } from "../models/IWorkingHour";
import { configWithUserFileToken, configWithUserToken } from "./config";

export const getRestaurantById = (restaurantId: string) => {
  return configWithUserToken.get<IRestaurantDetail>(
    "Restourants/" + restaurantId
  );
};

export const getRestaurantList = () => {
  return configWithUserToken.get<RestaurantList>(
    "Restourants/restourantList?pageIndex=0&pageSize=100"
  );
};

// Yalnız SuperAdmin; müşteri listesinin aksine listelenmeyen restoranları da döner.
export const getAdminRestaurantList = () => {
  return configWithUserToken.get<AdminRestaurantList>(
    "Admin/restaurants?pageIndex=0&pageSize=100"
  );
};

export const postRestaurant =(restaurant: IRestaurantDetail) => {
  return configWithUserToken.post<IRestaurantDetail>(
    "Restourants/" , restaurant);
};

export const getRestaurantsDeliveryAddress = (restaurantId: string) => {
  return configWithUserToken.get<IRestaurantDeliveryAddress>(
    "RestourantDeliveryAddress/DeliveryAddressList/" + restaurantId
  );
};

export const postRestaurantDeliveryAddress = (newAdress: PutDeliveryAddress) => {
  return configWithUserToken.post<DeliveryAddress>(
    "RestourantDeliveryAddress/" , newAdress);
};

export const putRestaurantsDeliveryAddress = (newAdress: PutDeliveryAddress,id:string) => {
  const jsonString = JSON.stringify(newAdress);
    return configWithUserToken.put("RestourantDeliveryAddress/"+id, newAdress);
};

export const putRestaurants = (restaurant: IUpdateRestaurant,id:string) => {
  
    return configWithUserToken.put("Restourants/UpdateRestourant/"+id, restaurant);
};

export const deleteRestaurant = (id: string) => {
  return configWithUserToken.delete(`Restourants/${id}`);
};

export const uploadRestaurantLogo = (restaurantId: string, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return configWithUserFileToken.put(
    `Restourants/UploadRestaurantsLogoById/${restaurantId}`,
    formData
  );
};

export const uploadRestaurantFeaturedImage = (restaurantId: string, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return configWithUserFileToken.put(
    `Restourants/UploadRestaurantsFeaturedImageById/${restaurantId}`,
    formData
  );
};

export const ChangeRestaurantStatus = (isActive:boolean,id:string) => {
  const param={
    isEnabled:isActive
  }

    return configWithUserToken.put(
  `Restourants/ChangeRestourantStatus/${id}?isEnabled=${isActive}`
);
};

export const getWorkingHours = (restaurantId: string) =>
  configWithUserToken.get<IWorkingHour[]>(`RestaurantWorkingHours/${restaurantId}`);

export const postWorkingHour = (data: IWorkingHourCreate) =>
  configWithUserToken.post("RestaurantWorkingHours", data);

export const putWorkingHour = (data: IWorkingHourUpdate) =>
  configWithUserToken.put("RestaurantWorkingHours", data);